import moment from "moment";
import { StaffEmployment } from "@/model/StaffEmployment";
export class Staff {
  StaffID;
  StaffType;
  CandID;
  CompCode;
  EngName;
  EngLastName;
  ChiName;
  ChiLastName;
  BadgeNum;
  DocTypeCode;
  DocNum;
  Country;
  POB;
  Gender;
  District;
  Area;
  Addr;
  Email;
  Mobile;
  BankCode;
  BankAcNum;
  AcHolderName;
  DOB;
  MaritalStatus;
  SupervisorID;
  Photo;
  PhotoURL;
  PhotoFile;
  LetterHead;
  StaffEmgConts;
  StaffBenefitList;
  StaffJobHistoryList;
  StaffEmployHistoryList;
  StaffEmployment;
  StaffEmploymentList;
  StaffAcademicList;
  SkillCertList;
  StaffSkillCertsList;
  StaffAttachmentList;
  DateResign;
  DateLastWork;
  StaffFixAlwList;
  constructor() {
    this.StaffID = "";
    this.StaffType = "";
    this.CompCode = "";
    this.CandID = "";
    this.EngName = "";
    this.EngLastName = "";
    this.ChiName = "";
    this.ChiLastName = "";
    this.BadgeNum = "";
    this.DocTypeCode = "";
    this.DocNum = "";
    this.Country = "";
    this.POB = "";
    this.District = "";
    this.Area = "";
    this.Gender = "";
    this.Addr = "";
    this.Email = "";
    this.Mobile = "";
    this.BankCode = "";
    this.BankAcNum = "";
    this.AcHolderName = "";
    this.DOB = "";
    this.MaritalStatus = "";
    this.SupervisorID = "";
    this.Photo = "";
    this.PhotoURL = "";
    this.PhotoFile = "";
    this.LetterHead = "";
    this.StaffEmgConts = [];
    this.StaffBenefitList = [];
    this.StaffEmployment = new StaffEmployment();
    this.StaffJobHistoryList = [];
    this.StaffAcademicList = [];
    this.StaffEmployHistoryList = [];
    this.StaffEmploymentList = [];
    this.SkillCertList = [];
    this.StaffSkillCertsList = [];
    this.StaffAttachmentList = [];
    this.DateResign = "1900-01-01";
    this.DateLastWork = "1900-01-01";
    this.StaffFixAlwList = [];
  }
}



// WEBPACK FOOTER //
// ./src/model/Staff.js